import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  itemCard: {
    backgroundColor: colors.neutral.cotton,
    borderRadius: scale(16),
    marginBottom: scale(14),
    paddingHorizontal: scale(16),
    paddingVertical: scale(14),
    position: 'relative',
    shadowColor: colors.black,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6,
  },
  itemContainer: {
    flexDirection: 'row',
  },
  itemContent: {
    flex: 1,
  },
  itemHeader: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: scale(2),
  },
  itemTitle: {
    flex: 1,
    marginRight: scale(12),
  },
  itemDescription: {
    marginTop: scale(2),
  },
  itemTime: {
    flexShrink: 0,
    marginTop: scale(1),
  },
  listContentContainer: {
    flexGrow: 1,
    paddingBottom: scale(8),
    paddingHorizontal: scale(4),
    paddingTop: scale(4),
  },
  paginationLoaderContainer: {
    alignItems: 'center',
    paddingBottom: scale(12),
    paddingTop: scale(4),
  },
  markAllReadText: {
    color: colors.secondary.orchid,
  },
  markAllReadTextDisabled: {
    color: colors.disabled.smoke,
  },
  sectionDot: {
    backgroundColor: colors.primary.carnation,
    borderRadius: scale(4),
    height: scale(8),
    position: 'absolute',
    right: scale(12),
    bottom: scale(12),
    width: scale(8),
  },
  sectionDotPlaceholder: {
    height: scale(8),
    position: 'absolute',
    right: scale(12),
    bottom: scale(12),
    width: scale(8),
  },
  sectionHeader: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: scale(12),
  },
  sectionTitle: {
    color: colors.neutral.darkMist,
  },
});

export default styles;
